import "./icontools.css";
import { calculateEstimations } from "../domain-utils";

function Estimations({ n, k, domainIndex, domains }) {
    const estimations = calculateEstimations(n, k, domainIndex, domains);
    const numberWithThousandsSeparators = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u2009"); // unicode thin space
    };

    return (
        <div className={"estimations-container"}>
            <h3 className={"estimations-title"} id="estimations">Estimations</h3>
            <div>Resolution: {Math.round(estimations.resolution * 10) / 10} km</div>
            <div>
                No. of triangle cells: <p>{numberWithThousandsSeparators(estimations.triangles ?? NaN)}</p>
            </div>
        </div>
    );
}

export default Estimations;
